import inputFieldWidget from "./inputFieldWidget.js";

/**
 * Checkbox field
 *
 * _Options:_
 * text			label text
 * reversed			reverse text and checkbox
 *
 * See inputField for more options
 */
function checkboxFieldWidget(spec, my) {
	spec ||= {};
	my ||= {};

	const that = inputFieldWidget(spec, my);

	// Todo: consider moving that up in the hierarchy
	my.enabled = function () {
		return spec.enabled ?? true;
	};

	my.disabledText = spec.disabledText;
	my.dataTestName = spec.dataTestName;

	my.readValue = function () {
		return my.field.asJQuery().get(0).checked;
	};

	that.getName = function () {
		return spec.attribute;
	};

	my.renderInputFieldOn = function (html) {
		let input;
		const enabled = my.enabled();

		html.div(
			{
				klass: [
					"checkbox",
					spec.klass || "form-control",
					{ disabled: !enabled },
				],
			},
			html.label(
				{ class: { reversed: spec.reversed } },
				(html) => {
					input = html.input({
						type: "checkbox",
						name: spec.name,
						"data-test": my.dataTestName,
					});

					if (spec.attribute) {
						input.setAttribute("id", spec.attribute);
					}
				},
				(html) => {
					if (!spec.text) {
						return;
					}
					if (enabled) {
						html.render(spec.text);
					} else {
						html.span(
							{ klass: "disabled-label" },
							my.disabledText || spec.text,
						);
					}
				},
			),
		);

		input.click(() => {
			my.updateValue(...arguments);
			my.updateCheckedAttribute(input);
		});

		my.updateCheckedAttribute(input);

		if (!enabled) {
			input.asJQuery().attr("disabled", true);
		}

		return input;
	};

	my.registerChangeOnBlur = function () {
		// do nothing
	};

	my.updateCheckedAttribute = function (input) {
		input.asJQuery().attr("checked", that.getValue());
	};

	return that;
}

export default checkboxFieldWidget;
